import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [usuario, setUsuario] = useState(() => {
    const token = localStorage.getItem('saturnpro_token');
    const stored = localStorage.getItem('saturnpro_usuario');
    if (!token) {
      localStorage.removeItem('saturnpro_usuario');
      return null;
    }
    return stored ? JSON.parse(stored) : null;
  });

  async function login(email, password) {
    const res = await api.post('/auth/login', { email, password });
    const { token, usuario } = res.data;
    localStorage.setItem('saturnpro_token', token);
    localStorage.setItem('saturnpro_usuario', JSON.stringify(usuario));
    setUsuario(usuario);
    return usuario;
  }

  useEffect(() => {
    const token = localStorage.getItem('saturnpro_token');
    if (!token) return;

    api.get('/auth/me')
      .then((res) => setUsuario(res.data))
      .catch((err) => {
        // Solo cerrar sesión si el token es inválido (401), no por error de red ni 403
        if (err.response?.status === 401) {
          localStorage.removeItem('saturnpro_token');
          localStorage.removeItem('saturnpro_usuario');
          setUsuario(null);
        }
        // Si es error de red o 403 (licencia/permisos), mantener sesión con datos locales
      });
  }, []);

  function logout() {
    localStorage.removeItem('saturnpro_token');
    localStorage.removeItem('saturnpro_usuario');
    setUsuario(null);
  }

  async function refreshUsuario() {
    try {
      const res = await api.get('/auth/me');
      localStorage.setItem('saturnpro_usuario', JSON.stringify(res.data));
      setUsuario(res.data);
    } catch (_) {}
  }

  return (
    <AuthContext.Provider value={{ usuario, login, logout, refreshUsuario }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
